

<template>
  <div>
    <div class="back" @click="back()">
      <i></i>
      <span>返回</span>
    </div>
    <el-card v-loading="loading">
      <div class="main">
        <div class="main_title">
          <i class="iconfont icon-gl_kaoshi3x"></i>
          <h2>【{{ $parent.islooktestname }}】</h2>
          <p>（共{{ testdata.TestCount }}题）</p>
        </div>
        <!-- 操作 默认隐藏，在自定义题库管理 里面过来才能看到 -->
        <div class="operation_box" v-if="$parent.isedit === 0">
          <el-button @click="addnewtest">
            <i class="iconfont icon-xinzeng"></i>智能添题</el-button
          >
          <!-- <el-button> <i class="iconfont icon-shezhi"></i>题型设置</el-button> -->
          <!-- <el-button @click="cutcoms(6)">
            <i class="iconfont icon-shoudongtianjia"></i
            >手动添题(暂未处理)</el-button
          > -->
        </div>
        <!-- 题型小方块 -->
        <div class="topic_box">
          <div v-for="(item, index) in topicArr" :key="index">
            <div :class="{ isactive: isact == index }" @click="isselect(index)">
              <p>{{ item.Style }}</p>
              <p>({{ item.TestCount }}题)</p>
            </div>
          </div>
        </div>
        <!-- 手风琴部分 -->
        <div class="accordion">
          <div class="delete">
            <h2>
              {{ testCountTitle }}
              <!-- 一、A题型、包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。（5分） -->
            </h2>
            <i
              class="iconfont icon-qingkong"
              @click="deletestyletest"
              v-if="$parent.isedit === 0"
            ></i>
          </div>

          <el-collapse
            v-model="activeName"
            accordion
            v-for="(items, indexs) in topicArr[defualtiscat].testArr"
            :key="indexs"
            class="custom_hover"
          >
            <el-collapse-item :name="indexs">
              <template slot="title" slot-scope="">
                <div
                  v-if="
                    items.TestJSON.TestType === 'ATEST' ||
                    items.TestJSON.TestType === 'XTEST' ||
                    items.TestJSON.TestType === 'TKTEST' ||
                    items.TestJSON.TestType === 'PDTEST' ||
                    items.TestJSON.TestType === 'JDTEST'
                  "
                >
                  {{ indexs + 1 + "." + items.TestJSON.Title }}
                </div>

                <div v-if="items.TestJSON.TestType === 'BTEST'" class="btest">
                  <div
                    v-for="(itemz, indexz) in items.TestJSON.BTestItem"
                    :key="indexz + '' + indexs"
                    class="btestcontent"
                  >
                    {{ indexz + 1 + "." + itemz.Title }}
                    <!-- {{ indexz + 1 + "." + itemz.Title }} -->
                  </div>
                </div>

                <div v-if="items.TestJSON.TestType === 'A3TEST'" class="btest">
                  {{ indexs + 1 + "." + items.TestJSON.MainTitle }}
                </div>

                <div class="down_operation" v-if="$parent.isedit === 0">
                  <!-- 此处是编辑回传功能未做 -->
                  <el-tooltip
                    effect="darkbtn"
                    content="编辑"
                    placement="top-start"
                  >
                    <i
                      class="iconfont icon-dati"
                      @click.stop="replace(items)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    effect="darkbtn"
                    content="删除"
                    placement="top-start"
                  >
                    <i
                      class="iconfont icon-qingkong"
                      @click.stop="deletea(indexs, items)"
                    ></i>
                  </el-tooltip>
                </div>
              </template>

              <div
                class="options"
                v-if="
                  items.TestJSON.TestType === 'ATEST' ||
                  items.TestJSON.TestType === 'XTEST' ||
                  items.TestJSON.TestType === 'TKTEST' ||
                  items.TestJSON.TestType === 'PDTEST' ||
                  items.TestJSON.TestType === 'JDTEST'
                "
              >
                <p
                  v-for="(item, index) in items.TestJSON.SelectedItem"
                  :key="index"
                  :class="{
                    istrue:
                      items.TestJSON.Answer.indexOf(sumcount(index)) != -1,
                  }"
                >
                  {{ sumcount(index) }} {{ item }}
                </p>
                <div>答案: {{ items.TestJSON.Answer }}</div>
              </div>

              <div class="options" v-if="items.TestJSON.TestType === 'BTEST'">
                <p
                  v-for="(itemq, indexq) in items.TestJSON.SelectedItem"
                  :key="indexq"
                  :class="{
                    istrue:
                      answerreduce(items.TestJSON.BTestItem).indexOf(
                        sumcount(indexq)
                      ) != -1,
                  }"
                >
                  {{ sumcount(indexq) }} {{ itemq }}
                </p>
                <div>答案: {{ answerreduce(items.TestJSON.BTestItem) }}</div>
              </div>

              <div class="options" v-if="items.TestJSON.TestType === 'A3TEST'">
                <div
                  v-for="(iteme, indexe) in items.TestJSON.A3TestItem"
                  :key="indexe"
                >
                  <h4>（{{ indexe + 1 }}）{{ iteme.Title }}</h4>
                  <p
                    v-for="(itemt, indext) in iteme.SelectedItem"
                    :key="indext"
                    :class="{
                      istrue: iteme.Answer[0].indexOf(sumcount(indext)) != -1,
                    }"
                  >
                    {{ sumcount(indext) }} {{ itemt }}
                  </p>
                  <div>答案: {{ iteme.Answer }}</div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 按钮 -->
        <!-- <div class="operation">
          <el-button class="succ_btn" @click="cutcoms(0)">上一步</el-button>
          <el-button type="success" class="submit_btn" @click="cutcoms(2)"
            >下一步</el-button
          >
        </div> -->
      </div>
      <!-- 提示小弹窗 -->
      <div class="delete_view">
        <el-dialog title="温馨提示" :visible.sync="dialogVisible">
          <div class="delete_mian">
            <i class="iconfont icon-tishi1"></i>
            <p v-if="deleteitle == '标题'">确定删除ssss吗？</p>
            <p v-if="deleteitle == '内容'">
              确定删除{{ deleteitem.TestJSON.Title }}吗？
            </p>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="deleteaitem">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <!-- dialog框 -->
      <testcope ref="dialog"></testcope>
    </el-card>
  </div>
</template>

<script>
//标题的总题数和总分数计算还不完全，。
import editqusetionbank from "@/api/editqusetionbank";
import {
  getChapterAllTest,
  DeleteImportSingleTest,
} from "@/api/quebankmana.js";
import testcope from "./testcopedialog.vue";
export default {
  props: ["cutcoms"],
  data() {
    return {
      // isedit:'',//1才是从编辑进来的。
      input1: "", //组件模式
      input2: "", //命题方式
      isact: "", //这是当前点击的活跃的题库类型
      defualtiscat: 0, //切换的题型的索引值
      activeName: "1",
      loading: false, //加载中，默认是空的
      titleTypeDesc: "", //每个题型的标题
      isShow: false, //上移下移操作
      dialogVisible: false, // 删除提示
      deleteitle: "", //要被删除的题头。 "标题" "内容"
      deleteitem: "", //要被删除的具体
      topicArr: [
        // 所有题型
        {
          titleType: "A题型",
          number: 5,
          score: 10,
          Explain:
            "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
          topicData: [
            //具体题目
            //A题型的全部问题
            {
              title: "动脉口位置（）", //A题型这道题组标题
              answer: "ABD", //A题型组这道题的答案
              TestCount: 9, // 分值
              options: [
                //A题型组这道题的选项
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
              ],
            },
            {
              title: "使重症肌无力病人的肌肉活动恢复正常可给予（）",
              answer: "B", //A题型组这道题的答案
              options: [
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
              ],
            },
            {
              title: "动脉口位置（）",
              answer: "A", //A题型组这道题的答案
              options: [
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
              ],
            },
          ],
        },
        {
          titleType: "B题型",
          number: 5,
          score: 10,
          Explain:
            "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
          topicData: [
            //具体题目
            //B题型的全部问题
            {
              title: "动脉口位置（）", //B题型这道题组标题
              answer: "A", //B题型组这道题的答案
              TestCount: 9, // 分值
              options: [
                //B题型组这道题的选项
                "B主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
              ],
            },
            {
              title: "使重症肌无力病人的肌肉活动恢复正常可给予（）",
              answer: "B", //B题型组这道题的答案
              options: [
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
              ],
            },
            {
              title: "动脉口位置（）",
              answer: "A", //B题型组这道题的答案
              options: [
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
              ],
            },
          ],
        },
        {
          titleType: "X题型",
          number: 5,
          score: 10,
          Explain:
            "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
          topicData: [
            //具体题目
            //X题型的全部问题
            {
              title: "动脉口位置（）", //X题型这道题组标题
              answer: "A", //X题型组这道题的答案
              TestCount: 9, // 分值
              options: [
                //X题型组这道题的选项
                "X主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
              ],
            },
            {
              title: "使重症肌无力病人的肌肉活动恢复正常可给予（）",
              answer: "B", //X题型组这道题的答案
              options: [
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
              ],
            },
            {
              title: "动脉口位置（）",
              answer: "A", //X题型组这道题的答案
              options: [
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
                "主动脉口",
              ],
            },
          ],
        },
        {
          titleType: "填空题",
          number: 5,
          score: 10,
          Explain:
            "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
          topicData: [],
        },
        {
          titleType: "判断题",
          number: 5,
          score: 10,
          Explain:
            "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
          topicData: [],
        },
        {
          titleType: "名词解释",
          number: 5,
          score: 10,
          Explain:
            "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
          topicData: [],
        },
        {
          titleType: "问答题",
          number: 5,
          score: 10,
          Explain:
            "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
          topicData: [],
        },
      ],
      testdata: "", //考试的信息
      dialogdata: "", //弹框的原始数据。
      addData: {}, // 编辑获取当前行
      editorData: {}, // 接口请求编辑回显数据
      editorState: 0, // 0是添加，1是编辑
    };
  },
  methods: {
    back() {
      this.cutcoms(1);
      this.$destroy();
    },
    addnewtest() {
      (this.editorState = 0), // 0是添加，1是编辑
        (this.$refs.dialog.dialogVisible = true);
    },
    // 汉字范围一
    numberChinese(number) {
      const strNumber = number.toString();
      const len = strNumber.length;
      let numberCh = "";
      for (let i = 0; i < len; i++) {
        let currentNum = strNumber.substr(i, 1);
        switch (currentNum) {
          case "0":
            numberCh += "零";
            break;
          case "1":
            numberCh += "一";
            break;
          case "2":
            numberCh += "二";
            break;
          case "3":
            numberCh += "三";
            break;
          case "4":
            numberCh += "四";
            break;
          case "5":
            numberCh += "五";
            break;
          case "6":
            numberCh += "六";
            break;
          case "7":
            numberCh += "七";
            break;
          case "8":
            numberCh += "八";
            break;
          case "9":
            numberCh += "九";
            break;
          default:
            numberCh += "*";
        }
      }
      return numberCh;
    },
    numberToUpperCase(textIndex) {
      let newString = "";
      let newTextIndex = textIndex + 1 + "";

      function sum(value, index) {
        var newValue = "";
        if (textIndex === 9) {
          return !index ? "十" : "";
        }
        let isSeat = ~~textIndex > 9 && ~~textIndex < 19;
        switch (~~value) {
          case 1:
            newValue = !index ? (isSeat ? "" : "一") : "十一";
            break;
          case 2:
            newValue = !index ? (isSeat ? "" : "二") : "十二";
            break;
          case 3:
            newValue = !index ? (isSeat ? "" : "三") : "十三";
            break;
          case 4:
            newValue = !index ? (isSeat ? "" : "四") : "十四";
            break;
          case 5:
            newValue = !index ? (isSeat ? "" : "五") : "十五";
            break;
          case 6:
            newValue = !index ? (isSeat ? "" : "六") : "十六";
            break;
          case 7:
            newValue = !index ? (isSeat ? "" : "七") : "十七";
            break;
          case 8:
            newValue = !index ? (isSeat ? "" : "八") : "十八";
            break;
          case 9:
            newValue = !index ? (isSeat ? "" : "九") : "十九";
            break;
          case 0:
            newValue = "十";
            break;
          default:
            break;
        }
        return newValue;
      }

      for (let i = 0; i < newTextIndex.length; i++) {
        newString += sum(newTextIndex.substring(i, i + 1), i);
      }
      return newString;
    },
    isselect(index) {
      console.log(index);
      this.isact = index;
      this.defualtiscat = index;
      console.log(this.topicArr[this.defualtiscat].testArr);
      // console.log(this.topicArr[this.defualtiscat].topicData);
    },
    // 上移
    async onmoveup(index, row) {
      console.log(row["TestJSON"]);
      var that = this;
      console.log("上移", index, row, this.defualtiscat);
      console.log(that.topicArr[this.defualtiscat].testArr[index]);
      if (index > 0) {
        let parmar = {
          paperID: this.$parent.testinfomation.PaperID,
          testID: row.PaperTestID,
          type: 1, //上移
          guid: JSON.parse(localStorage.getItem("userlist")).guid,
          userID: JSON.parse(localStorage.getItem("userlist")).userID,
          hid: JSON.parse(localStorage.getItem("userlist")).hid,
          _examID: this.$parent.testinfomation.ExamID,
        };
        let res = await editqusetionbank.MoveTest(parmar);
        console.log(res);
        if (res.data.Data[0].result == 1) {
          this.$message({
            message: "上移成功",
            type: "success",
          });
        }
        let upDate = that.topicArr[this.defualtiscat].testArr[index - 1];
        that.topicArr[this.defualtiscat].testArr.splice(index - 1, 1);
        that.topicArr[this.defualtiscat].testArr.splice(index, 0, upDate);
      } else {
        alert("已经是第一条，不可上移");
      }
    },
    // 下移
    async onmovedown(index, row) {
      var that = this;
      console.log("下移", index, row);
      if (index + 1 === that.topicArr[this.defualtiscat].testArr.length) {
        alert("已经是最后一条，不可下移");
      } else {
        let parmar = {
          paperID: this.$parent.testinfomation.PaperID,
          testID: row.PaperTestID,
          type: 0, //上移
          guid: JSON.parse(localStorage.getItem("userlist")).guid,
          userID: JSON.parse(localStorage.getItem("userlist")).userID,
          hid: JSON.parse(localStorage.getItem("userlist")).hid,
          _examID: this.$parent.testinfomation.ExamID,
        };
        let res = await editqusetionbank.MoveTest(parmar);
        console.log(res);
        if (res.data.Data[0].result == 1) {
          this.$message({
            message: "下移成s功",
            type: "success",
          });
        }
        let downDate = that.topicArr[this.defualtiscat].testArr[index + 1];
        that.topicArr[this.defualtiscat].testArr.splice(index + 1, 1);
        that.topicArr[this.defualtiscat].testArr.splice(index, 0, downDate);
      }
    },
    async deletestyletest() {
      //删除一种类型题目。
      console.log(this.topicArr[this.defualtiscat]);
      let parmas = {
        //   paperStyleID: this.topicArr[this.defualtiscat].PaperStyleID,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        TestID: JSON.stringify(
          this.topicArr[this.defualtiscat].testArr.map((item) => {
            return item.TestJSON.ID;
          })
        ),
      };
      this.$confirm(
        `确认删除${this.topicArr[this.defualtiscat].Style}吗`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          DeleteImportSingleTest(parmas).then((res) => {
            console.log(res);
            if (res.data.Status == 200) {
              //  this.getpaperdata();
              this.dialogVisible = false;
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: "删除失败",
                type: "error",
              });
            }
          });
          this.getpaperdata();
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    //删除
    deletea(index, items) {
      console.log(this.topicArr);
      console.log(items);
      // this.testdata.
      this.deleteitle = "内容";
      items.index = index;
      this.deleteitem = items;
      this.dialogVisible = true;
    },
    async deleteaitem() {
      let parmas = {
        //  paperTestID: this.deleteitem.PaperTestID,
        examID: this.deleteitem.TestJSON.ID,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        // TestID: JSON.stringify([this.deleteitem.TestJSON.ID]),
        // 2025/1/14更改
        TestID: JSON.stringify([this.deleteitem.TestID]),
      };
      let res = await DeleteImportSingleTest(parmas);
      console.log(res);
      if (res.data.Status == 200) {
        this.getpaperdata();
        this.dialogVisible = false;
      }
      //   this.$message({
      //     message: `温馨提示，试卷总分(${this.testdata.TotalScore})不能低于及格线${this.$parent.testinfomation.PassScore},请重新设置试卷或及格线`,
      //     type: "warning",
      //   });
      //   this.dialogVisible = false;
      // }
    },
    async getpaperdata() {
      let parmas = {
        CptID: this.$parent.islooktestid,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        _examID: "",
      };
      // let pama = {
      //   PaperID: this.$parent.testinfomation.PaperID,
      //   guid: JSON.parse(localStorage.getItem("userlist")).guid,
      //   userID: JSON.parse(localStorage.getItem("userlist")).userID,
      // };
      let resa = await getChapterAllTest(parmas);
      //这里初始化一下全部数据，
      //这里包装最后一步请求的style里面的第1位置数据。
      // let styledata = {};
      // styledata["1"] = res.data.Data;
      //  this.$parent.CookieCpt =
      //  this.$parent.TestCount = this.$parent.paperinfomation[0].TestCount;
      // this.$parent.Style["1"] = res.data.Data;
      //   console.log(this.$parent.Style);
      //   let resa = await editqusetionbank.getPaperJSON(pama);
      if (resa.data.Status == 200) {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        resa.data.Data.styleArr.map((item) => {
          item.testArr.map((items) => {
            console.log(items.TestJSON);
            items.TestJSON = JSON.parse(items.TestJSON);
          });
        });
        this.testdata = resa.data.Data;
        // console.log(this.testdata);
        this.topicArr = resa.data.Data.styleArr;
      }
    },
    // 编辑数据回显
    theEchoQuery() {
      console.log('触发了回显');
      
      let textID = this.addData.TestJSON.TestType;
      if (textID == "TKTEST") {
        this.$refs.dialog.state = 1;
        this.$refs.dialog.form = {
          topic: "填空题",
          topicName: this.addData.StyleName,
        };
        this.$refs.dialog.ruleForm.Title = this.editorData.Title; // 题名称
        this.$refs.dialog.ruleForm.Answer = this.editorData.Answer.map(
          (item) => {
            return { value: item };
          }
        ); // 答案
        this.$refs.dialog.ruleForm.Explain = this.editorData.Explain; // 解析
      } else if (textID == "JDTEST") {
        this.$refs.dialog.state = 2;
        this.$refs.dialog.form = {
          topic: "问答题",
          topicName: this.addData.StyleName,
        };
        this.$refs.dialog.ruleForm.Title = this.editorData.Title; // 题名称
        this.$refs.dialog.ruleForm.isAnswer = this.editorData.Answer; // 答案
        this.$refs.dialog.ruleForm.Explain = this.editorData.Explain; // 解析
      } else if (textID == "ATEST") {
        this.$refs.dialog.state = 3;
        this.$refs.dialog.form = {
          topic: "单项选择题",
          topicName: this.addData.StyleName,
        };
        this.$refs.dialog.ruleForm.Title = this.editorData.Title; // 题名称
        this.$refs.dialog.ruleForm.radioArr = this.editorData.SelectedItem.map(
          (item) => {
            return { value: item };
          }
        ); // 选项
        this.$refs.dialog.ruleForm.isslectradio = this.editorData.Answer; // 答案
        this.$refs.dialog.ruleForm.Explain = this.editorData.Explain; // 解析
      } else if (textID == "XTEST") {
        this.$refs.dialog.state = 4;
        this.$refs.dialog.form = {
          topic: "多项选择题",
          topicName: this.addData.StyleName,
        };
        this.$refs.dialog.ruleForm.Title = this.editorData.Title; // 题名称
        this.$refs.dialog.ruleForm.options = this.editorData.SelectedItem.map(
          (item) => {
            return { value: item };
          }
        ); // 选项
        var reg = /[A-Z]/gi;
        this.$refs.dialog.ruleForm.checkList =
          this.editorData.Answer.match(reg); // 答案
        this.$refs.dialog.ruleForm.Explain = this.editorData.Explain; // 解析
      } else if (textID == "A3TEST") {
        console.log(this.addData.TestJSON.A3TestItem[0].Answer[0]);
        console.log(this.addData.TestJSON.A3TestItem[0].Answer, "Answer");
        if (
          Array.isArray(this.addData.TestJSON.A3TestItem[0].Answer) == false
        ) {
          this.addData.TestJSON.A3TestItem[0].Answer = [
            this.addData.TestJSON.A3TestItem[0].Answer,
          ];
        }
        console.log(this.addData.TestJSON.A3TestItem[0]);

        console.log(this.addData.TestJSON, "TestJSON",textID,'textID');

        let answerstring = this.addData.TestJSON.A3TestItem[0].Answer.reduce(
          (first, scend) => {
            return first + scend;
          }
        );
         console.log(answerstring,'answerstring');
         
        if (answerstring.length == 1) {
          this.$refs.dialog.state = 5;
          console.log(this.addData.StyleName,'this.addData.StyleName');
          this.$refs.dialog.form = {
            topic: "共用题干单选题",
            topicName: this.addData.StyleName,
          };
          // this.$refs.dialog.form.topic
          this.$refs.dialog.smallForm.MainTitle = this.editorData.MainTitle; // 题名称
          this.$refs.dialog.A3TestItem = this.editorData.A3TestItem;
          this.$refs.dialog.A3TestItem.map((item) => {
            [item.Answer] = item.Answer;
            item.SelectedItem = item.SelectedItem.map((zitem) => {
              return { value: zitem };
            });
          });
        } else if (answerstring.length > 1) {
          this.$refs.dialog.state = 6;
          
          this.$refs.dialog.form = {
            topic: "共用题干不定项选择题",
            topicName: this.addData.StyleName,
          };
          this.$refs.dialog.smallForm.MainTitle2 = this.editorData.MainTitle; // 题名称
          this.$refs.dialog.A3TestItem2 = this.editorData.A3TestItem;
          this.$refs.dialog.A3TestItem2.map((item) => {
            item.Answer = answerstring.split("");
            item.SelectedItem = item.SelectedItem.map((zitem) => {
              return { value: zitem };
            });
          });
        }
      } else if (textID == "BTEST") {
        this.$refs.dialog.state = 7;
        this.$refs.dialog.form = {
          topic: "配伍题",
          topicName: this.addData.StyleName,
        };
        this.$refs.dialog.isSmalFlorm = this.editorData; // 题名称
        this.$refs.dialog.isSmalFlorm.SelectedItem =
          this.$refs.dialog.isSmalFlorm.SelectedItem.map((zitem) => {
            return { value: zitem };
          });
      } else if (textID == "PDTEST") {
        this.$refs.dialog.state = 8;
        this.$refs.dialog.form = {
          topic: "判断题",
          topicName: this.addData.StyleName,
        };
        this.$refs.dialog.judgeForm.Title = this.editorData.Title;
        this.$refs.dialog.judgeForm.Explain = this.editorData.Explain;
        this.$refs.dialog.judgeForm.Answer = this.editorData.Answer;
        this.$refs.dialog.judgeForm.Title = this.editorData.Title;
      }
      this.editorState = 1; // 0是添加，1是编辑
      this.$refs.dialog.dialogVisible = true;
    },
    // 编辑数据回显
    async replace(row) {
      this.addData = row;
      let parmes = {
        TestID: row.TestID,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
      };
      const Data = await editqusetionbank.Query(parmes);
      if (Data.status == 200) {
        this.editorData = JSON.parse(Data.data.Data);
        this.theEchoQuery();
        console.log(this.editorData, "======>请求");
      }

      console.log(row);
      //this.$children[0].isnowselecttest = JSON.parse(JSON.stringify(items));
      // this.$parent.isselecttest = items;
    },
  },
  components: {
    testcope,
  },
  computed: {
    sumcount() {
      return function (index) {
        let a = index;
        switch (a) {
          case 0:
            return "A";
          case 1:
            return "B";
          case 2:
            return "C";
          case 3:
            return "D";
          case 4:
            return "E";
          case 5:
            return "F";
          case 6:
            return "G";
          case 7:
            return "H";
          case 8:
            return "I";
          case 9:
            return "J";
          case 10:
            return "K";
        }
        return a;
      };
    },
    testCountTitle() {
      return (
        this.numberToUpperCase(this.defualtiscat) +
        "、" +
        this.topicArr[this.defualtiscat].Style
      );
    },
    answerreduce() {
      return function (params) {
        if (params.length == 1) {
          return params[0].Answer[0]; //这个地方暂时只用数组内的一个答案为
        }
        let res = params.reduce((first, scend) => {
          console.log(first, "gvasfasfvasdasc", scend);
          if (typeof first === "string") {
            console.log(first, "发撒撒旦", scend.Answer[0]);
            return first + scend.Answer[0];
          } else {
            return first.Answer + scend.Answer;
          }
          // if (first.splice !== undefined) {
          //   console.log(first.Answer,"第一次",scend.Answer);
          //   return first + scend;
          // } else {
          //   console.log(first.Answer,"sdadasfas",scend.Answer);
          //   console.log(first.Answer + scend.Answer);
          //   return first + scend.Answer[0];
          // }
        });
        console.log(res);
        return res;
      };
    },
  },
  mounted() {},
  created() {
    this.loading = true;
    this.getpaperdata();
  },
};
</script>

<style lang="scss" scoped>
.back {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  border-radius: 0px 0px 10px 10px;
  margin-bottom: 24px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.showlabel {
  width: 100%;
  height: 98px;
  background-color: rgb(255, 255, 255);
  margin-bottom: 24px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  h4 {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    padding-left: 24px;
    padding-right: 24px;
  }
  .testtype {
    padding-left: 24px;
    padding-right: 24px;
    height: 50px;
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 50px;
    margin-right: 50px;
    &:nth-child(4) {
      background-color: #1890ff;
      color: #ffffff;
      padding-left: 49px;
      padding-right: 49px;
      cursor: pointer;
    }
  }
}
.operation {
  display: flex;
  margin-top: 60px;
  justify-content: center;
  align-items: center;
  padding-bottom: 100px;
  background-color: #ffffff;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-card__body {
  padding: 0px !important;
  border-radius: 10px;
}
.main {
  .main_title {
    display: flex;
    align-content: center;
    border-bottom: 1px solid #eeeeee;
    padding: 30px 24px 20px 24px;

    i {
      display: inline-block;
      font-size: 24px;
      color: #369eff;
      margin-right: 10px;
    }
    h2 {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
    }
    p {
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      transform: translateY(2px);
    }
  }
  .topic_box {
    padding: 24px;
    min-height: 145px;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    flex-wrap: wrap;
    div {
      width: 116px;
      height: 100px;
      margin-right: 24px;
      margin-bottom: 12px;
      position: relative;
      background-image: url("../../../../assets/topic/rec2.png");
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .isactive {
        background-image: url("../../../../assets/topic/rec3.png") !important;
        p {
          color: #ffff;
        }
      }
      &:hover {
        cursor: pointer;
        background-image: url("../../../../assets/topic/rec1.png");
        background-size: cover; // 背景图片铺满整个容器
        p {
          color: #1890ff;
        }
      }
      img {
        display: inline-block;
        width: 116px;
        height: 100px;
      }
      div {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
      p:nth-child(1) {
        width: 90%;
        margin-bottom: 10px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        text-overflow: -o-ellipsis-lastline;
      }
    }
  }
  .accordion {
    .delete {
      display: flex;
      justify-content: space-between;
      align-content: center;
      width: 100%;
      height: 70px;
      line-height: 26px;
      background: #d8edff;
      padding: 21px 24px;
      box-sizing: border-box;
      h2 {
        opacity: 1;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: bold;
      }
      i {
        font-size: 32px;
      }
    }
  }
}
.istrue {
  color: #1890ff !important;
}
::v-deep .el-collapse-item__header {
  padding: 8px 14px;
  font-size: 15px;
  font-weight: 400;
  border: 1px solid #70bafe;
  position: relative;
  height: auto;
  line-height: 15px;
  &:hover {
    background: #eff7ff;
  }
  .down_operation {
    position: absolute;
    right: 53px;
    display: none;
    i {
      display: inline-block;
      margin-right: 30px;
      color: #1890ff;
      font-size: 24px;
    }
  }
}
::v-deep .el-collapse-item__wrap {
  border: none;
}
::v-deep .el-collapse-item__arrow {
  font-size: 24px !important;
}
.options {
  padding: 14px 26px;
  p {
    color: #999999;
    margin-bottom: 12px;
  }
  div {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
}
// 按钮
.operation_box {
  display: flex;
  opacity: 1;
  height: 88px;
  border-radius: 4px;
  padding: 24px;
  border-bottom: 1px solid #eeeeee;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 115px;
    height: 40px;
    margin-right: 24px;
    color: #ffffff;
    letter-spacing: 1px;
    border: none !important;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
  }
  .el-button:nth-child(2) {
    background: #ee6717;
  }
  .el-button:nth-child(3) {
    background: #64b5ff;
  }
}
::v-deep.el-collapse {
  border-bottom: none !important;
}
// 弹窗
.delete_view {
  ::v-deep .el-dialog__header {
    height: 55px;
    background: linear-gradient(
      180deg,
      #64b5ff 0%,
      rgba(199, 228, 255, 1) 100%
    );
    opacity: 1;
    border-radius: 5px 5px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 50px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: center !important;
  }
  ::v-deep .el-dialog__body {
    padding: 20px 24px 30px 24px;
  }
  .delete_mian {
    display: flex;

    box-sizing: border-box;
    i {
      display: inline-block;
      font-size: 16px !important;
      color: #ffc664;
      text-align: center;
      margin-right: 10px;
      transform: translateY(4px);
    }
    p {
      text-align: left;
      font-size: 15px;
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
}
::v-deep .el-dialog {
  width: 441px;
  min-height: 188px;
  border-radius: 5px;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
  }
}
.hidden {
  display: none;
}
.According {
  display: block;
}
.custom_hover:hover {
  .down_operation {
    display: block;
  }
}
.nomove {
  opacity: 0;
  cursor: auto;
}
.btest {
  cursor: auto;
  width: 91%;
  line-height: 20px;
}
.btestcontent {
  margin-top: 8px;
}
</style>